import { useLogout } from "@/hooks/auth/useLogout";
import { useRoleBasedNavigation } from "@/hooks/auth/useRoleBasedNavigation";
import { LogOut, Menu } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router";
import { LanguageSelect } from "../shared/general/language-select";
import { Button } from "../ui/button";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "../ui/sheet";

interface MobileNavigationProps {
  className?: string;
  triggerClassName?: string;
  variant?: "default" | "glass";
}

const MobileNavigation: React.FC<MobileNavigationProps> = ({
  className = "",
  triggerClassName = "",
  variant = "default",
}) => {
  const { t } = useTranslation("common");
  const { handleLogout } = useLogout();
  const location = useLocation();
  const { navigationItems } = useRoleBasedNavigation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const renderNavigationItem = (item: any) => {
    const isActive =
      item.path === location.pathname ||
      (item.path !== "/dashboard" && location.pathname.startsWith(item.path));

    return (
      <Link
        key={item.id}
        to={item.path}
        className={`text-body1 block px-4 py-3 transition-colors duration-200 ${
          isActive
            ? "text-blue-bg"
            : "hover:text-blue-normal-hover text-black-500"
        }`}
        onClick={() => setIsMobileMenuOpen(false)}
      >
        {t(`user.${item.id}`)}
      </Link>
    );
  };

  return (
    <div className={className}>
      <Sheet open={isMobileMenuOpen} onOpenChange={setIsMobileMenuOpen}>
        <SheetTrigger asChild>
          <Button
            variant="ghost"
            size="sm"
            className={`p-2 ${triggerClassName} ${variant === "glass" ? "text-white" : "text-blue-normal"}`}
          >
            <Menu className="size-6" />
          </Button>
        </SheetTrigger>
        <SheetContent side="right" className="w-64">
          <SheetHeader className="pb-4">
            <SheetTitle className="text-left">{t("ui.navigation")}</SheetTitle>
            <SheetDescription></SheetDescription>
          </SheetHeader>
          <nav className="flex flex-col space-y-1">
            {navigationItems.map((item) => renderNavigationItem(item))}
            {/* Mobile Logout Button */}
            <button
              onClick={() => {
                handleLogout();
                setIsMobileMenuOpen(false);
              }}
              className="text-body1 block border-b border-gray-100 px-4 py-3 text-left text-gray-700 transition-colors duration-200 hover:bg-red-50 hover:text-red-600"
            >
              <div className="flex items-center gap-3">
                <LogOut className="size-5" />
                <span>{t("buttons.logout")}</span>
              </div>
            </button>
            <div className="px-4 pt-3">
              <LanguageSelect />
            </div>
          </nav>
        </SheetContent>
      </Sheet>
    </div>
  );
};

export default MobileNavigation;
